import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SegmentCustomEvent } from '@ionic/angular';

export interface ITabGetm {
  id: number;
  title: string;
  active: boolean;
}

@Component({
  selector: 'app-tabs-getm',
  templateUrl: './tabs-getm.component.html',
  styleUrls: ['./tabs-getm.component.scss']
})
export class TabsGetmComponent {

  @Input() tabs: ITabGetm[] = [];
  @Input() selected: number = 0;
  @Output() tabChange = new EventEmitter<number>();

  public onSegmentChange = (event: SegmentCustomEvent): void => {
    const newValue = event.detail.value as number;
    this.tabChange.emit(newValue);
  }
}
